// extracted by mini-css-extract-plugin
export default {"indicators":"styles_indicators__p9L-z","active":"styles_active__hWYET"};